import { h as __h } from "preact";
import { Component, toChildArray } from "preact";
/** @import { ComponentChildren } from "preact"; */

import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./ObjectPage.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./ObjectPage.module.css", import.meta.url);
const css = adopt(sheet);

/** @param {ComponentChildren} actions */
const renderActions = actions => toChildArray(actions).length > 0 && __h("div", {
  "class": css.actions
}, actions);

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {{ href: string; name: string }} [backlink]
 * @property {ComponentChildren} title
 * @property {ComponentChildren} [desc]
 * @property {ComponentChildren} [actions]
 * @property {ComponentChildren} [sidebar]
 * @property {ComponentChildren} [children]
 */
export default class ObjectPage extends Component {
  render() {
    return __h("div", {
      "class": css.objectPage
    }, __h("div", {
      "class": css.header
    }, this.props.backlink && __h("a", {
      href: this.props.backlink.href,
      "class": css.backlink
    }, __h(Icon, {
      name: "back",
      size: 14
    }), __h("span", {}, this.props.backlink.name)), __h("span", {
      "class": css.title + " " + util.truncate
    }, this.props.title), this.props.desc && __h("span", {
      "class": css.desc
    }, this.props.desc)), renderActions(this.props.actions), __h("div", {
      "class": css.main
    }, __h("div", {}, this.props.children), this.props.sidebar && __h("div", {}, this.props.sidebar)));
  }
}

/**
 * @extends {Component<SectionProps>}
 *
 * @typedef {object} SectionProps
 * @property {ComponentChildren} title
 * @property {ComponentChildren} [children]
 * @property {ComponentChildren} [actions]
 * @property {string} [empty]
 */
export class ObjectPageSection extends Component {
  render() {
    return __h("div", {
      "class": css.objectPageSection
    }, __h("div", {
      "class": css.header
    }, __h("span", {
      "class": css.title
    }, this.props.title), renderActions(this.props.actions)), __h("div", {
      "class": css.cell,
      "data-empty": this.props.empty
    }, this.props.children));
  }
}